import {
	Button,
	Icon,
} from "src/components";
import { APP_CONFIG } from "src/models/constants";
import { useRootPageContext } from "../RootPage.context";
import { Flex } from "@scaleaq/sui-react";
import styling from "./Header.module.scss";
import { CompanySelector } from "./CompanySelector/CompanySelector";

export const Header = () => {
	// *****************************************
	// Properties
	// *****************************************

	const { sideMenuOpen, setSideMenuOpen } = useRootPageContext();

	// *****************************************
	// Render
	// *****************************************

	return (
		<Flex.Row
			render={<header />}
			alignment="center-left"
			justifyContent="space-between"
			className={styling["header-wrapper"]}
		>
			<Flex.Row
				render={<nav />}
				alignment="center-left"
				className={styling.left}
				gap="2xlarge"
			>
				<Button
					onClick={() => {
						setSideMenuOpen(!sideMenuOpen);
					}}
					paddingRule="icon-only"
					leftIcon={<Icon name={"LargeMenu"} size="small" />}
					color="neutral"
					variant="ghost"
				/>
			</Flex.Row>
			<Flex.Row>
				<Button
					href="/"
					variant="ghost"
					color="neutral"
					leftIcon={<Icon className={styling["logo--icon"]} name="ProductsKnowledger" size="small" />}
					className={styling.logo}
					text={APP_CONFIG.appName}
				/>
			</Flex.Row>
			<Flex.Row
				render={<nav />}
				alignment="center-right"
				className={styling.right}
				gap={"2xlarge"}
			>
				<Button
					leftIcon={<Icon name="LargeNotifications" />}
					paddingRule="icon-only"
					color="neutral"
					variant="ghost"
				/>
				<CompanySelector />
			</Flex.Row>
		</Flex.Row>
	);
};
